import React, { useCallback, useState, useMemo } from "react";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { TextInput } from "../UIkit";

const useStyles = makeStyles({
  iconCell: {
    padding: 0,
    height: 48,
    width: 48,
  },
  checkIcon: {
    float: "right",
  },
  inputText: {
    display: "flex",
    gap: "10px",
  },
  id: {
    width: "60px",
  },
});

const SetShopsArea = (props) => {
  const classes = useStyles();
  const [index, setIndex] = useState(0),
    [id, setId] = useState(""),
    [sid, setSid] = useState(""),
    [name, setName] = useState(""),
    [fax, setFax] = useState(""),
    [to, setTo] = useState(""),
    [cc, setCc] = useState("");
  const [editingIndex, setEditingIndex] = useState(-1);

  const inputSid = useCallback(
    (event) => {
      setSid(event.target.value);
    },
    [setSid]
  );

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );

  const inputFax = useCallback(
    (event) => {
      setFax(event.target.value);
    },
    [setFax]
  );
  const inputTo = useCallback(
    (event) => {
      setTo(event.target.value);
    },
    [setTo]
  );
  const inputCc = useCallback(
    (event) => {
      setCc(event.target.value);
    },
    [setCc]
  );

  const addShop = (index, sid, name, fax, to, cc) => {
    if (sid === "" || name === "" || fax === "" || to === "") {
      return false;
    } else {
      if (index === props.shops.length) {
        props.setShops((prevState) => [
          ...prevState,
          { id: "", sid: sid, name: name, fax: fax, to: to, cc: cc },
        ]);
        //props.setShops(prevState => [...props.shops, {id:"", sid:sid, name:name}])
        setIndex(index + 1);
        setSid("");
        setName("");
        setFax("");
        setTo("");
        setCc("");
      } else {
        const newShops = props.shops;
        newShops[index] = {
          ...newShops[index],
          sid: sid,
          name: name,
          fax: fax,
          to: to,
          cc: cc,
        };
        props.setShops(newShops);
        setIndex(newShops.length);
        setSid("");
        setName("");
        setFax("");
        setTo("");
        setCc("");
      }
      setEditingIndex(-1);
    }
  };

  // const editShop = (index, sid, name) =>{
  //     setIndex(index);
  //     setSid(sid);
  //     setName(name);
  // }
  const editShop = (index, sid, name, fax, to, cc) => {
    setIndex(index);
    setSid(sid);
    setName(name);
    setFax(fax);
    setTo(to);
    setCc(cc);
    setEditingIndex(index); // 編集中の行をセット
  };

  const deleteShop = (deleteIndex) => {
    const newShops = props.shops.filter((item, i) => i !== deleteIndex);
    props.setShops(newShops);
  };
  const memoIndex = useMemo(() => {
    setIndex(props.shops.length);
  }, [props.shops.length]);

  return (
    <div aria-label="販売店展開">
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          {/* ヘッダー部分はそのまま */}
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>販売店名</TableCell>
              <TableCell className={classes.iconCell} />
              <TableCell className={classes.iconCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {props.shops.length > 0 &&
              props.shops.map((item, i) => (
                <React.Fragment key={i}>
                  {/* 通常の行 */}
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {item.sid}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() =>
                          editShop(
                            i,
                            item.sid,
                            item.name,
                            item.fax,
                            item.to,
                            item.cc
                          )
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell className={classes.iconCell}>
                      <IconButton
                        className={classes.iconCell}
                        onClick={() => deleteShop(i)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  {/* 編集中の行の場合、入力フィールドをここに表示 */}
                  {editingIndex === i && i !== props.shops.length - 1 && (
                    // <TableRow>
                    //     {/* 入力フィールド */}
                    //     <TableCell colSpan={4}>
                    //         {/* ここにTextInputコンポーネント */}
                    //         {/* ... */}
                    //     </TableCell>
                    // </TableRow>
                    <TableRow>
                      <TableCell colSpan={4}>
                        <div>
                          <div className={classes.inputText}>
                            <div className={classes.id}>
                              <TextInput
                                fullWidth={false}
                                label={"ID"}
                                multiline={false}
                                required={true}
                                onChange={inputSid}
                                minRows={1}
                                value={sid}
                                type={"text"}
                              />
                            </div>
                            <TextInput
                              fullWidth={true}
                              label={"販売店名"}
                              multiline={false}
                              required={true}
                              onChange={inputName}
                              minRows={1}
                              value={name}
                              type={"text"}
                            />
                          </div>
                          <div>
                            <TextInput
                              fullWidth={false}
                              label={"FAX"}
                              multiline={false}
                              required={true}
                              onChange={inputFax}
                              minRows={1}
                              value={fax}
                              type={"text"}
                            />
                          </div>
                          <div>
                            <TextInput
                              fullWidth={true}
                              label={"アドレス(To)「,」で区切る"}
                              multiline={true}
                              required={true}
                              onChange={inputTo}
                              rows={2}
                              value={to}
                              type={"text"}
                            />
                          </div>
                          <div>
                            <TextInput
                              fullWidth={true}
                              label={"アドレス(CC)「,」で区切る"}
                              multiline={true}
                              required={true}
                              onChange={inputCc}
                              rows={2}
                              value={cc}
                              type={"text"}
                            />
                          </div>
                        </div>
                        <IconButton
                          className={classes.checkIcon}
                          onClick={() => addShop(index, sid, name, fax, to, cc)}
                        >
                          <CheckCircleIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
        {/* 編集中の行がない場合、入力フィールドを通常通りここに表示 */}
        {(editingIndex === -1 || editingIndex === props.shops.length - 1) && (
          <>
            <div>
              <div className={classes.inputText}>
                <TextInput
                  fullWidth={false}
                  label={"ID"}
                  multiline={false}
                  required={true}
                  onChange={inputSid}
                  minRows={1}
                  value={sid}
                  type={"text"}
                />
                <TextInput
                  fullWidth={false}
                  label={"販売店名"}
                  multiline={false}
                  required={true}
                  onChange={inputName}
                  minRows={1}
                  value={name}
                  type={"text"}
                />
              </div>
              <div>
                <TextInput
                  fullWidth={false}
                  label={"FAX"}
                  multiline={false}
                  required={true}
                  onChange={inputFax}
                  minRows={1}
                  value={fax}
                  type={"text"}
                />
              </div>
              <div>
                <TextInput
                  fullWidth={true}
                  label={"アドレス(To)「,」で区切る"}
                  multiline={true}
                  required={true}
                  onChange={inputTo}
                  rows={2}
                  value={to}
                  type={"text"}
                />
              </div>
              <div>
                <TextInput
                  fullWidth={true}
                  label={"アドレス(CC)「,」で区切る"}
                  multiline={true}
                  required={true}
                  onChange={inputCc}
                  rows={2}
                  value={cc}
                  type={"text"}
                />
              </div>
            </div>
            <IconButton
              className={classes.checkIcon}
              onClick={() => addShop(index, sid, name, fax, to, cc)}
            >
              <CheckCircleIcon />
            </IconButton>
          </>
        )}
        {/* <div className={classes.inputText}>
                    <TextInput
                        fullWidth={false} label={"ID"} multiline={false} required={true}
                        onChange={inputSid} minRows={1} value={sid} type={"text"}
                    />
                    <TextInput
                        fullWidth={false} label={"カテゴリー名"} multiline={false} required={true}
                        onChange={inputName} minRows={1} value={name} type={"text"}
                    />
                </div>
                <IconButton className={classes.checkIcon} onClick={() => addShop(index, sid, name)}>
                    <CheckCircleIcon/>
                </IconButton> */}
      </TableContainer>
      <div className="module-spacer--small" />
    </div>
  );
};

export default SetShopsArea;
